
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  toRefs,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import { SwipeCell, Cell, Popup, Button, Dialog, Loading } from "vant";
import { getUserInfo, parseImgUrl } from "@/utils";
import {
  deleteWorkSpace,
  queryWorkSpace,
  saveWorkSpace,
} from "@/apis/envmonitor";

export default defineComponent({
  components: {
    VanSwipeCell: SwipeCell,
    VanCell: Cell,
    // VanPopup: Popup,
    VanButton: Button,
    VanDialog: Dialog,
  },
  setup() {
    const proxyGlobal: any = getCurrentInstance();
    const userInfo: any = getUserInfo();
    const spaceData: any = [];
    const router: any = useRouter();
    const proxyData = reactive({
      show: false,
      userInfo: userInfo,
      loaging: false,
      parseImgUrl: parseImgUrl,
      // 格式化提交的数据
      formateData(item: any) {
        let params: any = {
          workSpaceList: [],
          majorSpaceId: "", //类型：String  必有字段  备注：主空间
          macAddress: proxyData.userInfo.mac, //类型：String  必有字段  备注：平板地址
        };
        proxyData.spaceData.map((space: any) => {
          if (item.spaceId === space.spaceId) {
            params.majorSpaceId = space.spaceId;
          }
          params.workSpaceList.push(space.spaceId);
        });
        return params;
      },
      // 选择主空间
      checkMainSpace(item: any) {
        if (!proxyData.loaging) {
          let params: any = proxyData.formateData(item);
          proxyData.saveWorkSpace(params);
        }
      },
      // 删除工作空间
      delWorkSpace(item: any) {
        let params: any = {
          spaceId: item.spaceId,
          macAddress: proxyData.userInfo.mac,
        };
        deleteWorkSpace(params).then(() => {
          proxyData.queryWorkSpace()
        });
      },
      // 保存空间
      saveWorkSpace(params: any) {
        proxyData.loaging = true;
        proxyGlobal.proxy.$toast.loading({
          forbidClick: true,
          duration: 0, // 如果大于0则不必使用destory方法
          message: "正在设置主空间...",
        });
        saveWorkSpace(params)
          .then((res) => {
            proxyData.closeLoading();
            router.push({
              name: "envmonitor",
              query: { spaceId: params.majorSpaceId },
            });
          })
          .catch(() => {
            proxyData.closeLoading();
          });
      },
      closeLoading() {
        proxyGlobal.proxy.$toast.clear();
        proxyData.loaging = false;
      },
      spaceData: spaceData,
      queryWorkSpace() {
        let params: any = {
          criteria: {
            projectId: proxyData.userInfo.projectId,
            //类型：Object  必有字段  备注：无
            macAddress: proxyData.userInfo.mac, //类型：String  必有字段  备注：mac地址
          },
        };
        // debugger
        queryWorkSpace(params).then((res) => {
          let resData: any = res ? res : {};
          // debugger;
          if (resData.result === "success") {
            proxyData.spaceData = resData?.content ?? [];
          } else {
            proxyData.spaceData = [];
          }
          // 默认都不是主空间
          proxyData.spaceData.map((item: any) => {
            item.isMajorSpace = 0;
          });
        });
      },
    });
    onMounted(() => {
      proxyData.queryWorkSpace();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
